import React, { useState } from "react";
import styles from "./BirthdayModal.module.css";
import { toast } from "react-toastify";
import Auth from "../../utils/api/Auth";

const BirthdayModal = ({ show, onClose, userName, userEmail }) => {
  const [dateOfBirth, setDateOfBirth] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!dateOfBirth) {
      toast.error("Please enter your date of birth", {
        position: "top-left",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "dark",
      });
      return;
    }

    setIsSubmitting(true);

    try {
      await Auth.createAgentBirthday({
        name: userName,
        email: userEmail,
        dob: dateOfBirth,
      });

      toast.success("Profile information saved successfully!", {
        position: "top-left",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "dark",
      });

      onClose();
    } catch (err) {
      toast.error(err?.response?.data?.error?.message || "Failed to save profile information", {
        position: "top-left",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "dark",
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  if (!show) {
    return null;
  }

  return (
    <div className={styles.modalOverlay} onClick={onClose}>
      <div
        className={styles.modalContainer}
        onClick={(e) => e.stopPropagation()}
      >
        <button
          className={styles.closeButton}
          onClick={onClose}
          aria-label="Close modal"
          disabled={isSubmitting}
        >
          &times;
        </button>
        <div className={styles.modalContent}>
          <h2 className={styles.modalTitle}>Complete Your Profile</h2>
          <p className={styles.modalDescription}>
            Please provide your date of birth to continue
          </p>
          <form onSubmit={handleSubmit} className={styles.form}>
            <div className={styles.formGroup}>
              <label htmlFor="userName" className={styles.label}>
                Name
              </label>
              <input
                type="text"
                id="userName"
                value={userName}
                className={styles.inputDisabled}
                disabled
                readOnly
              />
            </div>
            <div className={styles.formGroup}>
              <label htmlFor="userEmail" className={styles.label}>
                Email
              </label>
              <input
                type="email"
                id="userEmail"
                value={userEmail}
                className={styles.inputDisabled}
                disabled
                readOnly
              />
            </div>
            <div className={styles.formGroup}>
              <label htmlFor="dateOfBirth" className={styles.label}>
                Date of Birth
              </label>
              <input
                type="date"
                id="dateOfBirth"
                value={dateOfBirth}
                onChange={(e) => setDateOfBirth(e.target.value)}
                className={styles.input}
                disabled={isSubmitting}
                // max={new Date().toISOString().split("T")[0]}
                required
              />
            </div>
            <button
              type="submit"
              className={styles.submitButton}
              disabled={isSubmitting}
            >
              {isSubmitting ? "Saving..." : "Save"}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default BirthdayModal;